import Vue from 'vue';

let helpers = {
  computed: {
    $betrieb() {
      if (this.$model && this.$model.betrieb) return this.$model.betrieb;
      return null;
    },
    $gnoemaDatensatz() {
      return {id: null, kontakt: {firma: 'GnöMa'}}
    },
    $staging() {
      if (process.env.STAGE == 'staging') return true;
      return false;
    },
  }
}

Vue.mixin(helpers);
export default helpers;
